import { jsx as m } from "react/jsx-runtime";
import F, { createContext as x, Component as T, createElement as S, isValidElement as D, useState as w, useEffect as L, Suspense as I } from "react";
import { useConfig as O } from "@cw-elements/config";
const j = x(null), y = {
  didCatch: !1,
  error: null
};
class R extends T {
  constructor(t) {
    super(t), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = y;
  }
  static getDerivedStateFromError(t) {
    return {
      didCatch: !0,
      error: t
    };
  }
  resetErrorBoundary() {
    const {
      error: t
    } = this.state;
    if (t !== null) {
      for (var e, n, r = arguments.length, s = new Array(r), a = 0; a < r; a++)
        s[a] = arguments[a];
      (e = (n = this.props).onReset) === null || e === void 0 || e.call(n, {
        args: s,
        reason: "imperative-api"
      }), this.setState(y);
    }
  }
  componentDidCatch(t, e) {
    var n, r;
    (n = (r = this.props).onError) === null || n === void 0 || n.call(r, t, e);
  }
  componentDidUpdate(t, e) {
    const {
      didCatch: n
    } = this.state, {
      resetKeys: r
    } = this.props;
    if (n && e.error !== null && B(t.resetKeys, r)) {
      var s, a;
      (s = (a = this.props).onReset) === null || s === void 0 || s.call(a, {
        next: r,
        prev: t.resetKeys,
        reason: "keys"
      }), this.setState(y);
    }
  }
  render() {
    const {
      children: t,
      fallbackRender: e,
      FallbackComponent: n,
      fallback: r
    } = this.props, {
      didCatch: s,
      error: a
    } = this.state;
    let c = t;
    if (s) {
      const i = {
        error: a,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof e == "function")
        c = e(i);
      else if (n)
        c = S(n, i);
      else if (r === null || D(r))
        c = r;
      else
        throw a;
    }
    return S(j.Provider, {
      value: {
        didCatch: s,
        error: a,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, c);
  }
}
function B() {
  let o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return o.length !== t.length || o.some((e, n) => !Object.is(e, t[n]));
}
const b = "farm-settings", ee = `${b}/*`, p = "core-services-dynamic-slot-handshake", q = "core-services-dynamic-slot-mfe-opened", M = "core-services-dynamic-slot-change-props", U = (o) => typeof o == "object" && typeof o.then == "function", g = [];
function W(o, t, e = (n, r) => n === r) {
  if (o === t)
    return !0;
  if (!o || !t)
    return !1;
  const n = o.length;
  if (t.length !== n)
    return !1;
  for (let r = 0; r < n; r++)
    if (!e(o[r], t[r]))
      return !1;
  return !0;
}
function P(o, t = null, e = !1, n = {}) {
  t === null && (t = [o]);
  for (const s of g)
    if (W(t, s.keys, s.equal)) {
      if (e)
        return;
      if (Object.prototype.hasOwnProperty.call(s, "error"))
        throw s.error;
      if (Object.prototype.hasOwnProperty.call(s, "response"))
        return n.lifespan && n.lifespan > 0 && (s.timeout && clearTimeout(s.timeout), s.timeout = setTimeout(s.remove, n.lifespan)), s.response;
      if (!e)
        throw s.promise;
    }
  const r = {
    keys: t,
    equal: n.equal,
    remove: () => {
      const s = g.indexOf(r);
      s !== -1 && g.splice(s, 1);
    },
    promise: (
      // Execute the promise
      (U(o) ? o : o(...t)).then((s) => {
        r.response = s, n.lifespan && n.lifespan > 0 && (r.timeout = setTimeout(r.remove, n.lifespan));
      }).catch((s) => r.error = s)
    )
  };
  if (g.push(r), !e)
    throw r.promise;
}
const G = (o, t, e) => P(o, t, !1, e), Y = (o, t, e) => void P(o, t, !0, e), E = (o) => {
  console.warn(
    `Couldn't load ${o || "shell"} metadata, no dependencies are going to be shared nor modules are going to be exposed.`
  );
};
async function C(o = "", t = "") {
  return fetch(`${o}/remoteEntry.json`, { cache: "no-store" }).then((e) => e.ok ? e.json() : (E(t), Promise.resolve({ shared: [], exposes: [] }))).then((e) => {
    const n = t.split("/")[0];
    return [
      // Create shared dependencies map -> { dep: dep-path }
      e.shared.reduce((r, s) => {
        var c;
        const a = (c = s.exports) == null ? void 0 : c.reduce(
          (i, l) => ({
            [`${s.packageName}/${l}`]: `${s.path}/${l}`,
            ...i
          }),
          {}
        );
        return {
          [s.packageName]: s.path,
          ...a,
          ...r
        };
      }, {}),
      // Create exposed modules map -> { remote-origin/module: module-path  }
      e.exposes.reduce(
        (r, s) => ({
          [s.key.replace("./", `${n}/`)]: s.path.replace("./", `${o}/`),
          ...r
        }),
        {}
      )
    ];
  }).catch(() => (E(t), Promise.resolve([{}, {}])));
}
async function H(o) {
  let t = {}, e = {};
  o && await Promise.allSettled(
    Object.entries(o).map(
      ([n, r]) => C(r, n).then(([s, a]) => {
        e = { ...e, ...a }, t = { ...t, [r + "/"]: s };
      })
    )
  ), await C().then(([n]) => {
    const r = document.createElement("script");
    r.type = "importmap-shim", r.textContent = JSON.stringify({
      imports: { ...n, ...e },
      scopes: t
    }), document.body.appendChild(r);
  }).catch(() => {
    E();
  });
}
function N(o, t) {
  return o.replace(/[A-Z]/g, (e) => `${t}${e.toLowerCase()}`);
}
const h = window;
function K(o, t, e) {
  const n = `__${o}_${N(t, "_")}`, r = Math.floor(Math.random() * 1e9).toString(), s = `${n}_${r}`;
  h[n] = e;
  const a = h[n];
  return a && delete h[a], h[n] = s, h[s] = e, s;
}
function k({ meta: o }, t, e, n) {
  switch (o.props[t]) {
    case "function":
      return K(n, t, e);
    case "json":
      return JSON.stringify(e);
    default:
      return e;
  }
}
async function V(o) {
  var t, e;
  try {
    return await importShim(o).then(({ meta: r }) => {
      const s = Math.floor(Math.random() * 1e9).toString();
      return {
        default: (a) => F.createElement(
          r.tag,
          Object.entries(a).reduce(
            (c, [i, l]) => ({
              ...c,
              [N(i, "-")]: k({ meta: r }, i, l, s)
            }),
            {}
          )
        )
      };
    });
  } catch (n) {
    console.error(n);
    const r = ((t = o == null ? void 0 : o.split("/")) == null ? void 0 : t[0]) ?? "", s = ((e = o == null ? void 0 : o.split("/")) == null ? void 0 : e[1]) ?? o;
    throw new Error(
      `Couldn't load remote module, did you forgot to pass ${r} to initMfes? And are you sure ${s} is being exposed from ${r}?`
    );
  }
}
async function $(o, t) {
  const e = {
    prod: "https://d8ggsqqvoxvuj.cloudfront.net",
    staging: "https://d1gjwrdsdlsxfw.cloudfront.net",
    qa: "https://d3eo9ogup1du0j.cloudfront.net",
    local: "http://localhost:5000"
  };
  try {
    if (o) {
      const n = o.split("/").length > 1 ? o : `${o}/index`;
      return await H({
        [o]: `${e[t] ?? e.qa}/${o.split("/")[0]}`
      }), (await V(n)).default;
    }
  } catch (n) {
    throw console.warn(n), console.warn(
      "Your app is not configured to handle Cropwise Mfes, you may want to follow the steps on https://cw-elements.vercel.app/ to provide a better experience for your users"
    ), n;
  }
}
function A(o, t) {
  const e = O();
  return G($, [o, t || e.getCurrentEnv()]);
}
function J({ mfeKey: o, ...t }) {
  const e = A(o), [n, r] = w(() => {
    const s = {};
    for (const [a, c] of new URLSearchParams(window.location.search))
      s[a] = c;
    return s;
  });
  return L(() => {
    function s(i, l) {
      return Object.keys(l).reduce(
        (f, d) => (i.includes(d) && (f[d] = l[d]), f),
        {}
      );
    }
    function a(i) {
      const l = new URL(window.location.href);
      Object.entries(i).forEach(([f, d]) => {
        l.searchParams.set(f, d);
      }), window.history.pushState({}, "", l);
    }
    function c(i) {
      r((l) => {
        const f = Object.keys(l), d = i.detail ?? {}, v = s(f, d);
        return a(v), { ...l, ...v };
      });
    }
    return window.addEventListener(
      M,
      c
    ), () => window.removeEventListener(
      M,
      c
    );
  }, []), e && /* @__PURE__ */ m(e, { ...t, ...n });
}
const u = function() {
  function o() {
    let e;
    const n = window;
    return n.__GLOBAL_DYNAMIC_SLOT_INSTANCE__ ? e = n.__GLOBAL_DYNAMIC_SLOT_INSTANCE__ : (e = {
      path: b,
      navigate: null,
      dynamicSlotFound: !1
    }, n.__GLOBAL_DYNAMIC_SLOT_INSTANCE__ = e), e;
  }
  const t = o();
  return {
    set path(e) {
      t.path = e;
    },
    get path() {
      return t.path;
    },
    set navigate(e) {
      t.navigate = e;
    },
    get navigate() {
      return t.navigate;
    },
    set dynamicSlotFound(e) {
      t.dynamicSlotFound = e;
    },
    get dynamicSlotFound() {
      return t.dynamicSlotFound;
    }
  };
}();
function _() {
  var n, r;
  const o = (r = (n = window == null ? void 0 : window.location) == null ? void 0 : n.pathname) == null ? void 0 : r.split(`${u.path}/`).pop(), t = o == null ? void 0 : o.split("/");
  return (t == null ? void 0 : t[0]) ?? "";
}
function te(o) {
  const [t, e] = w(_());
  return L(() => {
    dispatchEvent(new CustomEvent(p));
    function n(r) {
      e(_()), r.detail();
    }
    return window.addEventListener(p, n), () => window.removeEventListener(p, n);
  }, []), /* @__PURE__ */ m(
    R,
    {
      fallback: /* @__PURE__ */ m("span", { children: "Failed Loading Dynamic Mfe" }),
      onError: () => {
        const n = new URLSearchParams(window.location.search).get("fallbackURL");
        n && (console.info(`Redirecting to Mfe on ${n}`), window.location.href = n);
      },
      children: /* @__PURE__ */ m(I, { fallback: "Loading Dynamic Mfe...", children: /* @__PURE__ */ m(J, { ...o, mfeKey: t }) })
    },
    t
  );
}
const X = /(^\/)|(\/$)/g;
function ne(o, t = u.path, e = []) {
  const r = O().getCurrentEnv();
  u.path = t.replace(X, ""), u.navigate = o, e.forEach((s) => {
    Y($, [s, r]);
  });
}
async function oe(o, t, e) {
  return new Promise((n) => {
    function r() {
      console.warn(
        "Your app is not configured to handle Cropwise Mfes, you may want to follow the steps on https://cw-elements.vercel.app/ to provide a better experience for your users"
      ), console.info(`Redirecting to Mfe on ${e}`), window.location.href = e, n();
    }
    const s = `${u.path}/${o}`;
    if (console.info(`Opening Mfe on ${s}`), !u.navigate)
      r();
    else {
      u.navigate(`${s}?${new URLSearchParams({ ...t, fallbackURL: e })}`);
      const a = () => {
        u.dynamicSlotFound = !0, n();
      };
      dispatchEvent(
        new CustomEvent(p, {
          detail: a
        })
      ), window.addEventListener(p, a), setTimeout(() => {
        u.dynamicSlotFound || r(), window.removeEventListener(p, a);
      }, 1e4);
    }
  }).then(() => dispatchEvent(new CustomEvent(q)));
}
function re(o, t) {
  const [e, n] = w(!0), [r, s] = w(!1), [a, c] = w(null);
  try {
    const i = A(o, t);
    e && (i ? c(() => i) : s(!0), n(!1));
  } catch (i) {
    e && !i.then && (s(!0), n(!1));
  }
  return {
    Mfe: a,
    isError: r,
    isLoading: e
  };
}
export {
  ee as CROPWISE_MFES_PATH,
  M as DYNAMIC_SLOT_CHANGE_PROPS,
  q as MFE_OPENED,
  te as default,
  ne as initMfeDynamicSlot,
  oe as openMfe,
  re as useMfe,
  A as useSuspendedMfe
};
